import { TrackingEventName } from '@/models/analytics/eventTypes';
import { trackCalculatorExecutedSpec, type CalculatorExecuted } from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const calculatorEvents: SnowplowEventMap = {
  [TrackingEventName.CalculatorExecuted]: (props) =>
    trackCalculatorExecutedSpec(props as CalculatorExecuted),
};
